<!-- eslint-disable -->
<template lang="pug">
		div(v-if="errorStatus === 403 || (user && authUser && (authUser.id !== user.id && user.isSuperadmin))")
				| {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
		div(v-else)
				user-form(v-if="user" :user="user" :type="user.type" :submit="update")
						template(slot="title")
								| {{ $i18n.t('user.user_edit_profileSettings') }}
						template(slot="button")
								| {{ $i18n.t('user.user_edit_refreshProfile') }}
				cs-loader(v-else="")
</template>

<script>
    /*eslint-disable*/
    import UserForm from './Form.vue'
    import UserApi from '../../api/user/user'
    import {mapState} from 'vuex'
    import moment from 'moment'

    export default {
        data() {
            return {
                user: null,
                errorStatus: null
            }
        },
        props: {
            id: {
                type: [Number, String],
                default: null
            }
        },
        mounted() {
            this.fetchData();
        },
        computed: {
            ...mapState({
                authUser: state => state.auth.user
            })
        },
        watch: {
            '$route' () {
                this.user = null;
                this.fetchData();
            }
        },
        methods: {
            fetchData() {
                UserApi.show(this.id)
                .then((data) => {
                    this.user = data;
                })
                .catch(err => {
                    this.errorStatus = err.status;
                });
            },
            update(user) {
                if (user.password === '') {
                    delete user.password;
                }
                return UserApi.update(this.id, user)
                .then((data) => {
                    if (this.authUser.id === user.id && user.locale !== this.user.locale) {
                        this.$i18n.locale = user.locale;
                        moment.locale(this.$i18n.locale);
                        this.$validator.localize(this.$i18n.locale)
                        this.authUser.locale = user.locale;
                    }
                    this.$router.push({name: 'user:profile', params: {id: data.id}});
                })
            }
        },
        components: {
            UserForm
        }
    }
</script>
